module.exports = __webpack_public_path__ + "img/business1.56021726.png";